<template>
	<CloLightbox
		v-if="open"
		reverse
		externalLightbox
		dataFormat="search2.0"
		mediaVersion="2.0"
		:list="lightboxData[view]"
		:goTo="goTo"
		:mediaDownloadUrl="mediaDownloadUrl"
		:ebirdWebUrl="ebirdWebUrl"
		:mediaSpecimenUrl="mediaSpecimenUrl"
		ratingEnabled
		:getRatingsUrl="getRatingsUrl"
		:saveRatingUrl="saveRatingUrl"
		:ratingCsrf="ratingCsrf"
		@close="close"
	></CloLightbox>
</template>

<script>
import CloLightbox from '@/media/CloLightbox/CloLightbox.vue';

// this prepares the data for the galllery view and lightbox, so uses global variables
function prepareAndDisplayMedia() {
	if (!mediaJson.length) {
		return;
	}
	// sort media by participant with checklist owner's media first
	const participants = document.querySelectorAll('[data-participant-userid]')
	const participantIds = Array.prototype.map.call(participants, (participant) => {
		return participant.getAttribute('data-participant-userid');
	});
	const obsMediaElements = document.querySelectorAll('[data-media-id]');
		const obsMediaIds = Array.prototype.map.call(obsMediaElements, (media) => {
			return media.getAttribute('data-media-id');
		});
	let obsMediaSpeciesCodes = Array.prototype.map.call(obsMediaElements, (media) => {
		return media.getAttribute('data-media-speciescode');
	});
	obsMediaSpeciesCodes = [...new Set(obsMediaSpeciesCodes)];
	mediaJson = mediaJson.sort((a, b) => {
		if (obsMediaSpeciesCodes.indexOf(a.taxon.speciesCode) < obsMediaSpeciesCodes.indexOf(b.taxon.speciesCode)) {
			return - 1
		}
		if (obsMediaSpeciesCodes.indexOf(a.taxon.speciesCode) > obsMediaSpeciesCodes.indexOf(b.taxon.speciesCode)) {
			return 1
		}
		if (participantIds.indexOf(a.userId) < participantIds.indexOf(b.userId)) {
			return - 1
		}
		if (participantIds.indexOf(a.userId) > participantIds.indexOf(b.userId)) {
			return 1
		}
		if (obsMediaIds.indexOf(a.assetId.toString()) < obsMediaIds.indexOf(b.assetId.toString())) {
			return - 1
		}
		if (obsMediaIds.indexOf(a.assetId.toString()) > obsMediaIds.indexOf(b.assetId.toString())) {
			return 1
		}
		return 0;
	});

	// make label in lightbox say "Tags" rather than "Behaviors"
	// so it make sense for photo and video
	// now that we are grouping all tags together
	langMap['obsMedia.behaviors'] = langMap['mediaTag.tags.label'];
	// combine data from html and mediaJson, and manipulate until it works
	var assets = document.querySelectorAll('[data-media-id]');
	var locationName = document.querySelector('[data-locationname]').textContent;
	if (assets.length && mediaJson.length) {
		mediaJson.forEach(function (el) {
			var asset = document.querySelector('[data-media-id="' + el.assetId + '"]');
			var data = el;
			var speciesCode = asset.getAttribute('data-media-speciescode');

			// TODO: do we really not have this data to show unconfirmed?
			data.valid = true
			data.assetId = data.assetId.toString();
			data.userDisplayName = asset.getAttribute('data-media-userdisplayname');
			var mediaType = asset.getAttribute('data-media-mediatype');
			data.mediaType = mediaType === 'P' ? 'photo' : mediaType === 'A' ? 'audio' : 'video';
			data.exoticCategory = asset.getAttribute('data-media-exotic');
			if (data.exoticCategory === 'X') {
				data.exoticCategory = 'E';
			}
			data.taxonomy = {
				comName: asset.getAttribute('data-media-commonname'),
				sciName: asset.getAttribute('data-media-sciname'),
				speciesCode: speciesCode,
				reportAs: asset.getAttribute('data-media-reportas'),
				category: asset.getAttribute('data-media-taxoncategory'),
			};
			data.ebirdChecklistUrl = baseUrl + 'checklist/' + subId;
			data.ebirdChecklistId = subId
			data.previewUrl = assetDownloadUrl + data.assetId + '/';
			if (mediaType === 'A') {
				data.previewUrl += 'poster';
			}
			if (mediaType === 'V') {
				data.previewUrl += 'thumb';
			}
			data.mediaDownloadUrl = assetDownloadUrl;
			data.obsDt = chkDateDisplayDate;
			data.obsDtDisplay = chkDateDisplayDate;
			data.location = { 
				name: locationName,
				subnational2Name: null,
				subnational1Name: null,
				countryName: null
			};
			data.specimenUrl = macaulayUrl + data.assetId;
			data.source = 'ebird';

			data.tags = data.assetTagCodes;
			data.subjectData = [
				{
					subjectTags: {},
				},
			];

			if (data.playback) {
				data.playback = langMap['playback_' + data.playback];
			}
			if (data.userId) {
				var participant = document.querySelector('[data-participant-userid="' + data.userId + '"]');
				if (participant && participant.href) {
					data.userHasProfile = true;
				}
			}

            data.rating = data.ratingAverage;
            data.ratingCount = data.ratingCount;

			if (data.hasOwnProperty('ratingForUserId')) {
				data.userRating = data.ratingForUserId.userRating;
				data.rating = data.ratingAverage;
				// count and average are not updated fast enough,
				// so we have to fake it if the user just uploaded a rated an asset
				if (data.ratingCount == 0) {
					data.ratingCount = 1;
					data.rating = data.userRating;
				}
			}
			
			// "media notes" is the new name for comments
			data.mediaNotes = data.comments;

			// make array of assets in each species
			if (typeof obsMediaData[speciesCode] !== 'undefined') {
				obsMediaData[speciesCode].push(data);
			} else {
				obsMediaData[speciesCode] = [];
				obsMediaData[speciesCode].push(data);
			}
		});

		for (var speciesCode in obsMediaData) {
			// copy to flat lightbox array
			obsMediaData[speciesCode].forEach(function (obs) {
				lightboxData.all.push(obs);
			});
			// has photos or audio?
			var hasPhotos = false;
			var hasAudio = false;
			var hasVideo = false;
			obsMediaData[speciesCode].forEach(function (obs) {
				if (obs.mediaType === 'photo') {
					hasPhotos = true;
				}
				if (obs.mediaType === 'audio') {
					hasAudio = true;
				}
				if (obs.mediaType === 'video') {
					hasVideo = true;
				}
			});
			if (hasPhotos) {
				obsMediaData[speciesCode].forEach(function (obs) {
					lightboxData.photos.push(obs);
				});
			}
			if (hasAudio) {
				obsMediaData[speciesCode].forEach(function (obs) {
					lightboxData.audio.push(obs);
				});
			}
			if (hasVideo) {
				obsMediaData[speciesCode].forEach(function (obs) {
					lightboxData.video.push(obs);
				});
			}
		}
	}
}

export default {
    name: 'ChecklistReportLightbox',
    components: { CloLightbox },
    data() {
        return {
            obsMediaData: window.obsMediaData,
            lightboxData: window.lightboxData,
			open: false,
			goTo: 0,
			view: 'all'
        };
    },
    props: {
        mediaDownloadUrl: {
            type: String,
            required: true,
        },
        ebirdWebUrl: {
            type: String,
            required: true,
        },
        mediaSpecimenUrl: {
            type: String,
            required: true,
        },
		getRatingsUrl: {
			type: String,
			required: true,
		},
		saveRatingUrl: {
			type: String,
			required: true,
		},
		ratingCsrf: {
			type: String,
			required: true,
		},
    },
    mounted() {
        prepareAndDisplayMedia();
		document.addEventListener('checklist-report-lightbox-open', (e) => {
			// keep lightbox contents in siync with the current view
			const query = new URLSearchParams(window.location.search);
			const view = query.get('view');
			this.view = view ? view : 'all'
			// go to the asset that was clicked
			this.goTo = e.detail;
			this.open = true
		});
	},
	methods: {
		close() {
			this.open = false;
		}
    },
}
</script>